import { Star } from 'lucide-react'
import { ImageHelper } from '../helpers/image.helper'

const HEADER_CONFIG = {
  TOP_BAR: {
    LEFT: [
      {
        title: 'VỀ COOLMATE',
        href: '/lp/coolmate-101?itm_source=navbar',
      },
      // {
      //   title: ' 84RISING*',
      //   href: '/84rising?itm_source=navbar',
      // },
      {
        title: 'COOLXPRINT',
        href: '/lp/coolxprint-mo-hinh-dat-san-xuat-theo-yeu-cau?itm_source=navbar',
      },
    ],
    RIGHT: [
      {
        title: 'CoolClub',
        href: '/page/coolclub-chuong-trinh-khach-hang-than-thiet-cua-coolmate?itm_source=navbar',
        icon: Star,
      },
      {
        title: 'Blog',
        href: '/blog',
        className: 'opacity-60 hover:opacity-100',
      },
      {
        title: 'Trung tâm CSKH',
        href: '/page/trung-tam-dich-vu-khach-hang?itm_source=navbar',
        className: 'opacity-60 hover:opacity-100',
      },
      {
        title: 'Đăng nhập',
        href: '/login',
        className: 'opacity-60 hover:opacity-100',
      },
    ],
  },
}

const FOOTER_CONFIG = {
  title: 'COOLMATE lắng nghe bạn!',
  description:
    'Chúng tôi luôn trân trọng và mong đợi nhận được mọi ý kiến đóng góp từ khách hàng để có thể nâng cấp trải nghiệm dịch vụ và sản phẩm tốt hơn nữa.',
  feedback: {
    title: 'Đóng góp ý kiến',
    link: 'https://form.omicrm.io/55551p112pi1e517p99h17h1',
  },
  contact: {
    hotline: {
      title: 'Hotline',
      numbers: ['1900.272737', '028.7777.2737'],
      workingHours: '8:30 - 22:00',
      iconUrl: '/images/footer/icon-hotline.svg',
    },
    email: {
      title: 'Email',
      address: 'Cool@coolmate.me',
      iconUrl: '/images/footer/icon-email.svg',
    },
  },
  socials: [
    {
      platform: 'Facebook',
      iconUrl: '/images/footer/icon-facebook.svg',
      url: 'https://www.facebook.com/coolmate.me',
    },
    {
      platform: 'Zalo',
      iconUrl: '/images/footer/icon-zalo.svg',
      url: 'https://zalo.me/1517736583279228381',
    },
    {
      platform: 'Tiktok',
      iconUrl: '/images/footer/icon-tiktok.svg',
      url: 'https://www.tiktok.com/@cool.coolmate',
    },
    {
      platform: 'Instagram',
      iconUrl: '/images/footer/icon-instagram.svg',
      url: 'https://www.instagram.com/coolmate.me/',
    },
    {
      platform: 'YouTube',
      iconUrl: '/images/footer/icon-youtube.svg',
      url: 'https://www.youtube.com/channel/UCWw8wLlodKBtEvVt1tTAsMA',
    },
  ],
  addresses: [
    {
      title: 'Văn phòng Hà Nội',
      address:
        'Tầng 3-4, Tòa nhà BMM, Km2, Đường Phùng Hưng, Phường Hà Đông, Thành phố Hà Nội, Việt Nam',
    },
    {
      title: 'Trung tâm vận hành Hà Nội',
      address:
        'Lô C8, KCN Lại Yên, Xã Lại Yên, Huyện Hoài Đức, Thành phố Hà Nội',
    },
    {
      title: 'Văn phòng và Trung tâm vận hành TP.HCM',
      address:
        'Lô C3, đường D2, KCN Cát Lái, Thạnh Mỹ Lợi, TP. Thủ Đức, TP. Hồ Chí Minh',
    },
    {
      title: 'Trung tâm R&D',
      address:
        'T6-01, The Manhattan Vinhomes Grand Park, Long Bình, TP. Thủ Đức',
    },
  ],
  companyInfo: {
    name: '@ CÔNG TY TNHH FASTECH ASIA',
    businessId: '0108617038',
    licenseInfo:
      'Mã số doanh nghiệp: 0108617038. Giấy chứng nhận đăng ký doanh nghiệp do Sở Kế hoạch và Đầu tư TP Hà Nội cấp lần đầu ngày 20/02/2019.',
    certifications: [
      {
        title: 'Chứng nhận Tín Nhiệm Mạng',
        url: 'https://tinnhiemmang.vn/danh-ba-tin-nhiem/coolmateme-1646213826',
        imageUrl: ImageHelper.getImageUrl('/uploads/March2022/handle_cert.png'),
      },
      {
        title: 'Chứng nhận ISO 9001',
        url: 'https://www.dmca.com/Protection/Status.aspx?ID=c6fdbdee-127c-4cf1-923d-7efe75201df6&refurl=https://www.coolmate.me/',
        imageUrl: ImageHelper.getImageUrl(
          '/uploads/March2022/dmca_protected_15_120.png'
        ),
      },
      {
        title: 'Chứng nhận ISO 14001',
        url: '#',
        imageUrl: '/images/footer/icon-iso-14001.png',
      },
      {
        title: 'Chứng nhận Hàng Việt Nam Chất Lượng Cao',
        url: 'http://online.gov.vn/(X(1)S(3e0hkhscv5zs101mhuopx43a))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
        imageUrl: '/images/footer/icon-hvnclc.png',
      },
    ],
  },
  menu: [
    [
      {
        title: 'CoolClub',
        items: [
          {
            label: 'Tài khoản CoolClub',
            url: '/account/info?itm_source=footerm',
            condition: "Cookie::get('user_info')",
          },
          {
            label: 'Đăng kí thành viên',
            url: '/register?itm_source=footerm',
            condition: "!Cookie::get('user_info')",
          },
          {
            label: 'Ưu đãi & Đặc quyền',
            url: '/coolclub?itm_source=footer',
          },
        ],
      },
      {
        title: 'Tài liệu - Tuyển dụng',
        items: [
          {
            label: 'Tuyển dụng',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'Đăng ký bản quyền',
            url: 'http://online.gov.vn/(X(1)S(sgmttobbtsiaq3l5itoicxhw))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
            target: '_blank',
          },
        ],
      },
    ],
    [
      {
        title: 'Chính sách',
        items: [
          {
            label: 'Chính sách đổi trả 60 ngày',
            url: '/page/dich-vu-60-ngay-doi-tra',
          },
          {
            label: 'Chính sách khuyến mãi',
            url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
          },
          {
            label: 'Chính sách bảo mật',
            url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
          },
          {
            label: 'Chính sách giao hàng',
            url: '/page/dich-vu-giao-hang-coolmate',
          },
        ],
      },
      {
        title: 'Coolmate.me',
        items: [
          {
            label: 'Lịch sử thay đổi website',
            url: '/page/changelog?itm_source=footer',
          },
        ],
      },
    ],
    [
      {
        title: 'Chăm sóc khách hàng',
        items: [
          {
            label: 'Trải nghiệm mua sắm 100% hài lòng',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
          },
          {
            label: 'Hỏi đáp - FAQs',
            url: '/page/faqs',
          },
        ],
      },
      {
        title: 'Kiến thức mặc đẹp',
        items: [
          {
            label: 'Hướng dẫn chọn size',
            url: '/size-chart',
          },
          {
            label: 'Blog',
            url: '/blog',
          },
        ],
      },
    ],
    [
      {
        title: 'Về COOLMATE',
        items: [
          {
            label: 'Quy tắc ứng xử của Coolmate',
            url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
          },
          {
            label: 'Coolmate 101',
            url: '/lp/coolmate-101?itm_source=footer',
          },
          {
            label: 'DVKH xuất sắc',
            url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
          },
          {
            label: 'Câu chuyện về Coolmate',
            url: '/page/coolmate-story?itm_source=footer',
          },
          {
            label: 'Nhà máy',
            url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
          },
          {
            label: 'Care & Share',
            url: '/collection/care-and-share?itm_source=footer',
          },
          {
            label: 'Cam kết bền vững',
            url: '/page/cam-ket-phat-trien-ben-vung?itm_source=footer',
          },
        ],
      },
    ],
  ],
  menuMobile: [
    {
      title: 'CoolClub',
      items: [
        {
          label: 'Tài khoản CoolClub',
          url: '/account/info?itm_source=footerm',
          condition: "Cookie::get('user_info')",
        },
        {
          label: 'Đăng kí thành viên',
          url: '/register?itm_source=footerm',
          condition: "!Cookie::get('user_info')",
        },
        {
          label: 'Ưu đãi & Đặc quyền',
          url: '/coolclub?itm_source=footer',
        },
      ],
    },
    {
      title: 'Chính sách',
      items: [
        {
          label: 'Chính sách đổi trả 60 ngày',
          url: '/page/dich-vu-60-ngay-doi-tra',
        },
        {
          label: 'Chính sách khuyến mãi',
          url: '/page/chuong-trinh-va-chinh-sach-khuyen-mai-tai-coolmate',
        },
        {
          label: 'Chính sách bảo mật',
          url: '/page/chinh-sach-bao-mat-thong-tin-ca-nhan',
        },
        {
          label: 'Chính sách giao hàng',
          url: '/page/dich-vu-giao-hang-coolmate',
        },
      ],
    },
    {
      title: 'Coolmate.me',
      items: [
        {
          label: 'Lịch sử thay đổi website',
          url: '/page/changelog?itm_source=footer',
        },
      ],
    },
    {
      title: 'Chăm sóc khách hàng',
      items: [
        {
          label: 'Trải nghiệm mua sắm 100% hài lòng',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet',
        },
        {
          label: 'Hỏi đáp - FAQs',
          url: '/page/faqs',
        },
      ],
    },
    {
      title: 'Kiến thức mặc đẹp',
      items: [
        {
          label: 'Hướng dẫn chọn size',
          url: '/size-chart',
        },
        {
          label: 'Blog',
          url: '/blog',
        },
      ],
    },
    {
      title: 'Tài liệu - Tuyển dụng',
      items: [
        {
          label: 'Tuyển dụng',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'Đăng ký bản quyền',
          url: 'http://online.gov.vn/(X(1)S(sgmttobbtsiaq3l5itoicxhw))/Home/WebDetails/53184?AspxAutoDetectCookieSupport=1',
          target: '_blank',
        },
      ],
    },
    {
      title: 'Về COOLMATE',
      items: [
        {
          label: 'Quy tắc ứng xử của Coolmate',
          url: '/page/quy-tac-ung-xu-cua-coolmate?itm_source=footer',
        },
        {
          label: 'Coolmate 101',
          url: '/lp/coolmate-101?itm_source=footer',
        },
        {
          label: 'DVKH xuất sắc',
          url: '/page/11-dich-vu-tai-coolmate-co-the-ban-chua-biet?itm_source=footer',
        },
        {
          label: 'Câu chuyện về Coolmate',
          url: '/page/coolmate-story?itm_source=footer',
        },
        {
          label: 'Nhà máy',
          url: '/page/san-pham-coolmate-duoc-san-xuat-nhu-the-nao?itm_source=footer',
        },
        {
          label: 'Care & Share',
          url: '/collection/care-and-share?itm_source=footer',
        },
        {
          label: 'Cam kết bền vững',
          url: '/page/cam-ket-phat-trien-ben-vung?itm_source=footer',
        },
      ],
    },
    {
      title: 'Địa chỉ liên hệ',
      items: [
        {
          label:
            'Văn phòng Hà Nội: Tầng 3-4, Tòa nhà BMM, Km2, Đường Phùng Hưng, Phường Hà Đông, Thành phố Hà Nội, Việt Nam',
          url: '',
        },
        {
          label:
            'Trung tâm vận hành Hà Nội: Lô C8, KCN Lại Yên, Xã Lại Yên, Huyện Hoài Đức, Thành phố Hà Nội',
          url: '',
        },
        {
          label:
            'Văn phòng và Trung tâm vận hành TP.HCM: Lô C3, đường D2, KCN Cát Lái, Thạnh Mỹ Lợi, TP. Thủ Đức, TP. Hồ Chí Minh',
          url: '',
        },
        {
          label:
            'Trung tâm R&D: T6-01, The Manhattan Vinhomes Grand Park, Long Bình, TP. Thủ Đức',
          url: '',
        },
      ],
    },
  ],
}

export const LAYOUT_CONFIG = {
  HEADER: HEADER_CONFIG,
  FOOTER: FOOTER_CONFIG,
}
